import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { CampaignAuthorizationService } from '../services/campaign-authorization.service';

/**
 * Runs after `authGuard`. Redirects to `/forbidden` only on a confirmed zero-access
 * result; a resolution failure (network/server error) fails open and lets the user
 * proceed without a resolved Business Unit list (AZTGSA-12354 design.md, Decision 5).
 */
export const campaignAuthorizationGuard: CanActivateFn = () => {
  const authorizationService = inject(CampaignAuthorizationService);
  const router = inject(Router);

  return authorizationService.resolve().pipe(
    map((resolution) => (resolution.status === 'zero-access' ? router.createUrlTree(['/forbidden']) : true)),
  );
};
